<template lang="pug">
.split-view.hello
  .split-view-top
    transition-group.conversation(name="message" tag="div", v-chat-scroll="", ref="conversation", v-prevent-parent-scroll="")
      message(:message="welcome", :key="'welcome'")
      message(v-for="message, index in conversation", :message="message", :key="message._id")

  .split-view-bottom
    footer
      loading(:show="loading")
      transition(name="form", mode="out-in")
        .form(v-if="chatEnabled || candidate._id")
          form(v-on:submit.prevent="submitMessage")
            .field
              textarea(v-model="message.body", v-autosize="message.body", placeholder="Write a reply...", @keydown="checkSubmit", ref='message')
              .actions
                button.send-message(:disabled="sendingMessage")
                  i.fa.fa-paper-plane
          .powered-by
            span Powered by
            a.logo(v-if="isPF", href="https://www.peoplefluent.com/", target="_blank") PeopleFluent
            a.logo(v-else, href="https://breezy.hr/", target="_blank") breezy
        .form(v-else)
          div(v-if="postingCandidateError")
            p There was an error. Try again.
          form(v-on:submit.prevent="submitCandidate")
            .field.name
              input#candidateName(type="text", v-model="candidate.name", placeholder="What's your name?", :class="{error: errors.invalid.name}")

            .field.email-resume
              input(type="email", v-model="candidate.email_address", placeholder="What's your email address?", :class="{error: errors.invalid.email_address}")

            .field.gdpr(v-if="messenger.gdprEnabled")
              label
                input(type="checkbox", v-model="candidate.gdpr.consent", :class="{error: errors.invalid.consent}")
                span {{ messenger.templates.gdpr.body }} &nbsp;
              a(:href="privacyLink", target="_blank") View Privacy Notice


            .actions.clearfix
              .button-group-left
                button.button-link.resume(type="button", v-on:click="$upload.select('resume')")
                  div(v-if="$upload.meta('resume').status === 'ready'")
                    i.fa.fa-paperclip
                    span Upload Resume
                  div(v-if="$upload.meta('resume').status === 'sending'")
                    i.fa.fa-circle-o-notch.fa-spin.fa-fw
                    span Uploading...
                  div(v-if="$upload.meta('resume').status === 'complete'")
                    //- v-tooltip="{ content: 'Attached: ' + candidate.resume.file_name, placement: 'top' }"
                    i.fa.fa-file
                    span {{ candidate.resume.file_name }}
              .button-group-right
                button.submit(type="submit", :disabled="postingCandidate")
                  .sending(v-if="postingCandidate")
                    span.text Sending...
                    i.fa.fa-circle-o-notch.fa-spin.fa-fw
                  .not-sending(v-else)
                    span.text Save &amp; Send
                    i.fa.fa-paper-plane
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import message from '@/components/Message'
import loading from '@/components/Loading'
import api from '@/services/api'

const isEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

const replyTime = {
  day: 'They\'ll typically reply in a day',
  minutes: 'They\'ll typically reply in a few minutes',
  hours: 'They\'ll typically reply in a few hours',
  asap: 'They\'ll reply as soon as possible.'
}

export default {
  name: 'hello',
  components: {
    loading,
    message
  },
  data () {
    return {
      isPF: false,
      chatEnabled: true,
      postingCandidate: false,
      postingCandidateError: false,
      welcome: {
        object: {
          body: ''
        },
        type: 'messageToCandidatePosted'
      },
      message: {
        body: '',
        attachments: []
      },
      stored_message: {
        body: '',
        attachments: []
      },
      errors: {
        prevent: false,
        invalid: {
          email_address: false,
          resume: false,
          consent: false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['messenger', 'templates', 'candidate', 'conversation', 'visitor', 'sendingMessage', 'loading']),
    privacyLink () {
      return `https://${this.messenger.company.friendly_id}.${this.$route.query.portalDomain}/privacy-notice`
    }
  },
  created () {

    this.isPF = this.$route.query.isPF ? eval(this.$route.query.isPF) : false
    // DOCS
    // https://github.com/websanova/vue-upload
    let API_ROOT = api.getAPIRoot()
    let UPLOAD_PATH = `${API_ROOT}/portal/${this.messenger.company.friendly_id}/upload/resume`
    //console.log(`upload path = ${UPLOAD_PATH}`)
    this.$upload.new('resume', {
      url: UPLOAD_PATH,
      extensions: ['abw', 'djvu', 'doc', 'docx', 'html', 'lwp', 'md', 'odt', 'pages', 'pages.zip', 'pdf', 'rst', 'rtf', 'sdw', 'tex', 'txt', 'wpd', 'wps', 'zabw'],
      maxSizePerFile: this.isPF ? 4096 : 1024,
      onSuccess(res) {
        this.$store.commit('setCandidateResume', {
          file_name: res.body.file_name,
          url: res.body.url
        })
        // this.errors.invalid.resume = false
      },
      onError(err) {
        console.log('file upload err', err);
      },
      onSelect(files) {
        // console.log('onSelect', files);
      }
    })

    if (this.candidate._id) {
      this.$store.dispatch('getCandidateConversation')
    }
  },
  mounted () {
    this.welcome.object.body = this.messenger.templates.default.body
    /*this.$nextTick(function () {
      //console.log('ticked')
      //console.log(this.$refs.message)
      this.$refs.message.focus()
    })*/
  },
  watch: {
    // old school function declaration to maintain 'this' scope
    'candidate.email_address': function(val) {
      if (isEmail.test(val)) {
        this.errors.invalid.email_address = false
      }
    }
  },
  methods: {
    checkSubmit(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.submitMessage();
      }
    },
    submitMessage () {
      if (this.message.body.trim().length === 0) return
      
      // sanitize
      this.message.body = this.message.body.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;')

      if (this.candidate._id) {
        this.$store.dispatch('postMessageFromCandidate', this.message)
      } else {
        this.chatEnabled = false
        this.stored_message.body = this.message.body
        setTimeout(function() {
          document.querySelector('#candidateName').focus()
        }, 1000)
      }
      this.message = {
        body: '',
        attachments: []
      }
      //this.conversation.push(this.message)
    },

    submitCandidate (e) {
      this.errors.prevent = false
      if (this.candidate.name) {
        this.errors.invalid.name = false
      } else {
        this.errors.invalid.name = true
        this.errors.prevent = true
      }

      if (this.candidate.email_address) {
        this.errors.invalid.email_address = false
      } else {
        this.errors.invalid.email_address = true
        this.errors.prevent = true
      }

      if (this.messenger.gdprEnabled) {
        if (this.candidate.gdpr.consent) {
          this.errors.invalid.consent = false
        } else {
          this.errors.invalid.consent = true
          this.errors.prevent = true
        }
      }


      /*if (this.candidate.resume.url) {
        this.errors.invalid.resume = false
      } else {
        this.errors.invalid.resume = true
        this.errors.prevent = true
      }*/

      if (this.errors.prevent) return

      this.postingCandidate = true
      this.postingCandidateError = false

      this.$store.dispatch('postCandidate', {
        positionId: this.messenger.position_id,
        candidate: this.candidate
      }).then(result => {
        // now post message
        this.postingCandidate = false
        this.$store.dispatch('postMessageFromCandidate', this.stored_message).then(() => {
          // trigger auto reply
          this.$store.commit('UPDATE_CONVERSATION', {
            _id: new Date().getTime(),
            object: {
              body: replyTime[this.messenger.reply_time]
            },
            type: 'autoResponse'
          })
        })
      }, e => {
        this.postingCandidate = false
        this.postingCandidateError = true
      })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import('../assets/styles/_constants.styl')
.hello
  section
    p
      font-size 16px
      font-weight 300
      line-height 21px
      padding padding padding * 2

  .conversation
    height 100%
    overflow auto
    padding-top 15px

  .powered-by
    color rgba(255,255,255,.5)
    font-size 12px
    padding-bottom padding
    text-align center
    a
      color inherit
      font-size 14px
      font-weight 600
      margin-left 5px
      text-decoration none

  /* animations */
  .form-enter-active, .form-leave-active
    transition all .3s ease
  .form-enter, .form-leave-to
    opacity 0
    transform translate(0, 100%)
    //transform translate(0, 0)

</style>



// WEBPACK FOOTER //
// Hello.vue?56973a9c